import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import i18n from "../lang";


import Home from '../views/Home.vue'
import Content from '../views/Content.vue'
import ReContent from '../views/ReContent.vue'

import App from "../App.vue";
import Article from '../views/Article.vue'
import Ticket from '../views/Ticket.vue'
import Myticket from '../views/Myticket.vue'
import Login from '../views/Login.vue'
import Search from '../views/Search.vue'
import TicketList from '../views/TicketDetail.vue'
import Nfind from '../views/404.vue'
import Serve from '../views/Serve.vue'
import test from '../views/test.vue'
import Bind from '../views/Bind.vue'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: 'Party Animals'
        }
    },
    {
        path: '/bind',
        name: 'Bind',
        component: Bind
    },
    {
        path: '/faq',
        name: 'KNOW ISSUES',
        component: Content,
        children: [

        ]

    }, 
    // {
    //     path: '/test',
    //     name: 'test',
    //     component: test,

    // },
    {
        path: '/faq/:name',
        name: 'active',
        component: ReContent,
    },
    {
        path: '/article',
        name: 'Article',
        component: Article,
    },
    {
        path: '/tickets/new-tickets',
        name: 'submit a ticket',
        component: Ticket,
    },
    {
        path: '/tickets/my-tickets/:id',
        name: 'MyTicket',
        component: TicketList,
    },
    {
        path: '/tickets/my-tickets',
        name: 'Myticket',
        component: Myticket,

    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/search-results',
        name: 'search results',
        component: Search,
    },
    {
        path: '/server',
        name: 'Serve',
        component: Serve,
    },
    {
        path: '/*',
        name: 'Nfind',
        component: Nfind,
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})


router.beforeEach((to, from, next) => { //beforeEach是router的钩子函数，在进入路由前执行
    if (to.meta.title) { //判断是否有标题
        document.title = to.meta.title
    }
    console.log("Enter router");

    next(); // 跳转到目标路由，并带上修改后的查询参数
    // next() //执行进入路由，如果不写就不会进入目标页
})

export default router